import { useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { useLatestRequest } from "@/hooks/useLatestRequest";

const errorText = (err) => typeof err.response?.data?.detail === "string" ? err.response.data.detail : "Could not update enquiries. Please try again.";

export const useEnquiryDecisions = (setEnquiries) => {
  const [busy, setBusy] = useState(""), [error, setError] = useState("");
  const { run } = useLatestRequest();
  const merge = (results) => setEnquiries((old) => old.map((enquiry) => {
    const response = results.find((item) => item.enquiry_id === enquiry.id);
    return response ? { ...enquiry, triage: response.assessment, triage_override: response.override } : enquiry;
  }));
  const perform = (key, request, success) => {
    setBusy(key); setError("");
    return run(request, success, (err) => setError(errorText(err)), () => setBusy(""));
  };
  const action = (id, method, data, suffix = "") => perform(id,
    (signal) => axios({ method, url: `${API}/admin/enquiries/${id}/decision${suffix}`, data, signal }),
    (response) => merge([response.data]));
  const analyseNext = (enquiries) => perform("batch", async (signal) => {
    const results = []; let failure = "";
    const pending = enquiries.filter((item) => !item.triage_override && item.triage?.status !== "ready").slice(0, 10);
    for (const item of pending) {
      try {
        const { data } = await axios.post(`${API}/admin/enquiries/${item.id}/decision`, null, { signal });
        results.push(data);
        if (data.assessment?.status !== "ready") break;
      } catch (err) { if (axios.isCancel(err)) throw err; failure = errorText(err); break; }
    }
    return { results, failure };
  }, ({ results, failure }) => { merge(results); setError(failure); });
  const refresh = () => perform("refresh", (signal) => axios.get(`${API}/admin/enquiries`, { signal }), (response) => setEnquiries(response.data));
  return { busy, error, analyse: (id) => action(id, "post"), save: (id, data) => action(id, "patch", data),
    reset: (id) => action(id, "delete", undefined, "/override"), analyseNext, refresh };
};